module.exports = __webpack_public_path__ + "img/nyamoko1.1dd8b9c9.jpg";